import {Component} from 'react';
import h from 'react-hyperscript';
import {h4} from 'Components/Typography/Typography';
import BasicCard from 'Components/Cards/BasicCard';

class ArchiveEmpty extends Component {
  render() {
    return (
      h('div', {
        className: 'report-overview__archive report-overview__archive--empty',
      }, [
        h(h4, {
          key: 'report-overview__header',
          className: 'report-overview__header',
        }, `${this.props.userStatus.email}'s ${this.props.title}`),
        h(BasicCard, {
          type: 'basic',
        }, [
          h('table', null, [
            h('thead', null, [
              h('tr', null,
                  this.props.headers.map((item, i) => {
                    return (
                      h('th', {
                        key: item.id,
                        className: 'text--grey text--bold',
                      }, item.title)
                    );
                  })
              ),
            ]),
            h('tbody', null, h('tr', {
              className: 'archive__row',
            }, h('td', {
              className: 'text--grey',
            }, 'There are no reports available yet.'))),
          ]),
        ]),
      ])
    );
  }
}

export default ArchiveEmpty;
